import { Construction } from "@mui/icons-material"
import { Box, Paper, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"

/**
 * Placeholder for a legacy mobilus-webapp screen whose delivery2 route exists
 * but whose feature is not built yet (DEV-394). One component for every such
 * route; the route's own `ui` id marks the surface.
 */
export const WorkInProgressPage: FC<{ titleKey: string }> = ({ titleKey }) => {
  const { t } = useTranslation()

  return (
    <Box
      data-testid="wip-page"
      sx={{ display: "flex", justifyContent: "center", py: 8, px: 3 }}
    >
      <Paper
        variant="outlined"
        sx={{
          p: 6,
          borderRadius: 3,
          maxWidth: 480,
          width: "100%",
          textAlign: "center",
          bgcolor: "background.paper",
        }}
      >
        <Stack alignItems="center" spacing={3}>
          <Box
            sx={{
              width: 88,
              height: 88,
              borderRadius: "50%",
              bgcolor: "primary.50",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Construction sx={{ fontSize: 44, color: "primary.main" }} />
          </Box>
          <Box>
            <Typography
              data-testid="wip-page-title"
              variant="h5"
              fontWeight={700}
              color="text.primary"
              gutterBottom
            >
              {t(titleKey)}
            </Typography>
            <Typography
              data-testid="wip-page-message"
              variant="body1"
              color="text.secondary"
            >
              {t("wip.message")}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Box>
  )
}
